var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Undo component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconUndo extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.01909 2.38482C9.31199 2.09193 9.31199 1.61706 9.01909 1.32416C8.7262 1.03127 8.25133 1.03127 7.95843 1.32416L4.05658 5.22601C3.88829 5.3943 3.8167 5.62267 3.8418 5.84208C3.86219 6.02233 3.94648 6.18322 4.07147 6.30156L7.95843 10.1885C8.25133 10.4814 8.7262 10.4814 9.01909 10.1885C9.31199 9.89563 9.31199 9.42075 9.01909 9.12786L6.39807 6.50684H12.0005C13.4728 6.50684 14.912 6.94341 16.1361 7.76136C17.3603 8.5793 18.3144 9.74188 18.8778 11.1021C19.4412 12.4623 19.5886 13.959 19.3014 15.4029C19.0142 16.8469 18.3052 18.1733 17.2641 19.2143C16.2231 20.2554 14.8967 20.9643 13.4528 21.2516C12.0088 21.5388 10.5121 21.3914 9.15187 20.828C7.79168 20.2646 6.62911 19.3105 5.81116 18.0863C4.99322 16.8622 4.55664 15.423 4.55664 13.9507C4.55664 13.5365 4.22085 13.2007 3.80664 13.2007C3.39243 13.2007 3.05664 13.5365 3.05664 13.9507C3.05664 15.7197 3.58119 17.4489 4.56396 18.9197C5.54672 20.3905 6.94357 21.5368 8.57785 22.2138C10.2121 22.8907 12.0104 23.0678 13.7454 22.7227C15.4803 22.3776 17.074 21.5258 18.3248 20.275C19.5756 19.0242 20.4275 17.4305 20.7726 15.6956C21.1177 13.9606 20.9405 12.1623 20.2636 10.528C19.5867 8.89376 18.4403 7.49692 16.9695 6.51415C15.4987 5.53139 13.7695 5.00684 12.0005 5.00684H6.39708L9.01909 2.38482Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconUndo.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconUndo.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconUndo.prototype, "size", void 0);
if (customElements.get('cat-icon-undo') === undefined) {
    customElements.define('cat-icon-undo', BlocksIconUndo);
}
